import React, { useContext } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import logozoco from "../../assets/img/logo-modo-oscuro.png";
import logopayway from "../../assets/img/payway-texto.png";
import logomercadopago from "../../assets/img/Logo-Mercado-Pago-4.png";
import logonx from "../../assets/img/Logo-Naranja-X-4.png";
import logogetnet from "../../assets/img/Logo-Getnet-4.png";
import logoviumi from "../../assets/img/Logo-viuMi-(Con-espacio-abajo).png";
import logoNave from "../../assets/img/Logo-Nave-(Con-espacio-abajo).png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

const TituloPaginaAhorro = ({
  ahorroMercadoPago,
  ahorroPayway,
  ahorroNaranjaX,
  ahorroGetnet,
  ahorroViumi,
  netoZoco,
  ahorroNave,
}) => {
  const { darkMode } = useContext(DarkModeContext);

  // size: ancho del logo, calculado para que todos ocupen la misma area
  // visual segun la proporcion de su contenido visible.
  // ratio: ancho / alto del contenido visible. Nave y viuMi traen espacio
  // transparente abajo; el ratio recorta ese espacio al mostrarlos.
  const comparativas = [
    { logo: logopayway, ahorro: ahorroPayway, size: 35, ratio: "170 / 147" },
    { logo: logogetnet, ahorro: ahorroGetnet, size: 38, ratio: "203 / 147" },
    { logo: logonx, ahorro: ahorroNaranjaX, size: 42, ratio: "252 / 147" },
    { logo: logomercadopago, ahorro: ahorroMercadoPago, size: 39, ratio: "214 / 147" },
    { logo: logoNave, ahorro: ahorroNave, size: 51, ratio: "380 / 147" },
    { logo: logoviumi, ahorro: ahorroViumi, size: 57, ratio: "447 / 146" },
  ];

  return (
    <section className={darkMode ? "aliado-savings-panel is-dark" : "aliado-savings-panel"}>
      <div className="aliado-savings-zoco">
        <img src={logozoco} alt="Zoco Logo" />
        <div>
          <span>Recibis</span>
          <strong>{netoZoco}</strong>
        </div>
      </div>
      <div className="aliado-savings-list">
        {comparativas.map((item, idx) => (
          <article className="aliado-savings-item" key={idx}>
            <span className="aliado-savings-logo">
              <img
                src={item.logo}
                alt="Competitor Logo"
                style={{ width: `${item.size}px`, aspectRatio: item.ratio }}
              />
            </span>
            <div>
              <span>Recibis</span>
              <strong>
                {item.ahorro}
                <FontAwesomeIcon icon={faArrowDown} className="aliado-savings-down" />
              </strong>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default TituloPaginaAhorro;
